/* eslint-disable react/jsx-no-duplicate-props */
import React from "react";
import { message } from "antd";
import { loginApi, userApi } from "@/api/api";
import token from "@/utils/token";
import "./loginModel.scss";
import { withRouter } from "react-router-dom";
import { switchCard, CodeModal } from '@/components';
import { Images } from '@/assets';
import { generateCancelToken } from '@/utils/index';
import { encryptByKeySize } from '@/utils/rsa';
import { isValidResetPassword } from '@/utils/password';
import PasswordLoginPanel from "./components/passwordLoginPanel";
import ForgotPasswordFlow from "./components/forgotPasswordFlow";

class LoginModel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loginModdelTab: props.type === 1 ? 1 : 0,
            authTab: "sms",
            agreement: 1,
            codeVisible: false,
            codeVisibleTarget: "login",
            loginForm: {
                phone: "",
                msgCode: "",
                err: "",
            },
            passwordForm: {
                phone: "",
                password: "",
                err: "",
            },
            registerForm: {
                phone: "",
                msgCode: "",
                name: "",
                company: "",
                province: "",
                city: "",
                distinct: "",
                err: "请准确输入信息，销售经理将尽快通过您填写的信息联系您",
            },
            loginTimerCount: 60,
            loginIfSendMsg: false,
            forgotVisible: false,
            forgotStep: "phone",
            forgotForm: {
                phone: "",
                code: "",
                password: "",
                confirmPassword: "",
                err: "",
            },
            forgotTimerCount: 60,
            forgotIfSendMsg: false,
            forgotVerifying: false,
            registTimerCount: 60,
            registIfSendMsg: false,
            areaList: {},
            provinceList: [],
            cityList: [],
            distinctList: [],
        };

        this.timer = null;

        this.removeModel = this.removeModel.bind(this);
        this.doLogin = this.doLogin.bind(this);
        // 初始化生成cancelToken实例和cancel方法
        const { cancel, cancelToken } = generateCancelToken();
        this.cancelToken = cancelToken;
        this.cancel = cancel;
    }

    componentDidMount() {
        const { isView } = this.props;
        const isLogin = !!token.getToken(); // 是否已登录
        if (!isView && isLogin) {
            this.fetchUserInfo();
        }
        // this.initAreaList();
    }

    componentWillUnmount() {
        if (this.cancel) this.cancel();
        if (this.timer) clearInterval(this.timer);
    }

    removeModel() {
        this.props.closeFun();
    }

    // initAreaList = () => {
    //     loginApi.fetchAreaList().then(res => {
    //         if (res) {
    //             this.setState({
    //                 areaList: res,
    //                 provinceList: res.province,
    //             })
    //         }
    //     })
    // }
    getToastMessage = (err) => {
        if (!err) return "";
        if (typeof err === "string") return err;
        if (typeof err === "object") {
            if (typeof err.message === "string" && err.message) return err.message;
            if (typeof err.msg === "string" && err.msg) return err.msg;
        }
        return "操作失败，请稍后重试";
    };

    setErr = (err) => {
        const toastMsg = this.getToastMessage(err);
        if (toastMsg) {
            message.error(toastMsg);
        }
        const { loginModdelTab, loginForm, registerForm } = this.state;
        if (loginModdelTab === 0) {
            const loginData = JSON.parse(JSON.stringify(loginForm));
            loginData.err = "";
            this.setState({
                loginForm: loginData,
            });
        } else if (loginModdelTab === 1) {
            const registData = JSON.parse(JSON.stringify(registerForm));
            registData.err = "";
            this.setState({
                registerForm: registData,
            });
        }
    };

    setPasswordErr = (err) => {
        const toastMsg = this.getToastMessage(err);
        if (toastMsg) {
            message.error(toastMsg);
        }
        const passwordData = JSON.parse(JSON.stringify(this.state.passwordForm));
        passwordData.err = "";
        this.setState({
            passwordForm: passwordData,
        });
    };

    setForgotErr = (err) => {
        const toastMsg = this.getToastMessage(err);
        if (toastMsg) {
            message.error(toastMsg);
        }
        const forgotData = JSON.parse(JSON.stringify(this.state.forgotForm));
        forgotData.err = toastMsg || "";
        this.setState({
            forgotForm: forgotData,
        });
    };

    fetchUserInfo = () => {
        const _this = this;
        userApi.fetchUserInfo({ cancelToken: this.cancelToken }).then(res => {
            if (!res.chooseCardUserIds) {
                switchCard.show(_this.props);
            } else {
                const { isView } = _this.props;
                if (isView) {
                    // 登陆成功之后的跳转
                    let redirectUrl = '/';
                    if (_this.props.location.state) {
                        const pathName = _this.props.location.state.from.pathname;
                        redirectUrl = (pathName === '/login' ? '/' : pathName);
                    }
                    _this.props.history.push(redirectUrl);
                } else {
                    window.location.reload();
                }
            }
        }).catch((e) => {
            if (!e.cancel && window.location.href.indexOf('login') > -1) {
                switchCard.show(_this.props);
            }
        });
    }

    doLogin() {
        const { loginForm, agreement } = this.state;
        // const reg = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/;
        const reg = /^[1][0-9]{10}$/;
        if (!reg.test(loginForm.phone)) {
            this.setErr("请输入正确的手机号");
            return;
        }
        if (!loginForm.msgCode) {
            this.setErr("请输入手机验证码");
            return;
        }
        if (agreement === 1) {
            this.setErr("请阅读并同意麦鲜达隐私协议");
            return;
        }

        this.setErr("");
        const params = {
            mobile: loginForm.phone,
            agreement: agreement,
            code: loginForm.msgCode,
        };
        loginApi
            .doLogin(params, { cancelToken: this.cancelToken })
            .then((res) => {
                token.setToken(res);
                token.setLoginPhone(loginForm.phone);
                this.fetchUserInfo();
            })
            .catch((err) => {
                if (!err.cancel) this.setErr(err);
            });
    }

    doPasswordLogin() {
        const { passwordForm, agreement } = this.state;
        const account = (passwordForm.phone || "").trim();
        const password = (passwordForm.password || "").trim();
        const phoneReg = /^[1][0-9]{10}$/;
        if (!account || !phoneReg.test(account)) {
            this.setPasswordErr("请输入正确的手机号");
            return;
        }
        if (!password) {
            this.setPasswordErr("请输入密码");
            return;
        }
        if (agreement === 1) {
            this.setPasswordErr("请阅读并同意麦鲜达隐私协议");
            return;
        }
        this.setPasswordErr("");
        const params = {
            mobile: account,
            password,
            agreement,
            loginType: 1,
        };
        loginApi
            .doLogin(params, { cancelToken: this.cancelToken })
            .then((res) => {
                token.setToken(res);
                token.setLoginPhone(account);
                this.fetchUserInfo();
            })
            .catch((err) => {
                if (!err.cancel) this.setPasswordErr(err);
            });
    }

    getCurrentPhone() {
        const {
            codeVisibleTarget,
            registerForm,
            loginForm,
            forgotForm,
        } = this.state;
        let phone = '';
        if (codeVisibleTarget === "forgot") {
            phone = forgotForm.phone;
        } else if (codeVisibleTarget === "register") {
            phone = registerForm.phone;
        } else {
            phone = loginForm.phone;
        }
        return phone;
    }

    showCodeModal(target = "login") {
        const {
            registIfSendMsg,
            loginIfSendMsg,
            loginForm,
            registerForm,
            forgotForm,
            authTab,
        } = this.state;

        // const reg = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/;
        const reg = /^[1][0-9]{10}$/;
        const currentTarget = target || (authTab === "sms" ? "login" : "forgot");
        if (currentTarget === "login" && !reg.test(loginForm.phone)) {
            this.setErr("请输入正确的手机号");
            return;
        } else if (currentTarget === "register" && !reg.test(registerForm.phone)) {
            this.setErr("请输入正确的手机号");
            return;
        } else if (currentTarget === "forgot" && !reg.test(forgotForm.phone)) {
            this.setForgotErr("请输入正确的手机号");
            return;
        }

        if (
            (currentTarget === "register" && !registIfSendMsg) ||
            (currentTarget === "login" && !loginIfSendMsg) ||
            (currentTarget === "forgot" && !this.state.forgotIfSendMsg)
        ) {
            this.setState({
                codeVisible: true,
                codeVisibleTarget: currentTarget,
            });
        }
    }

    hideCodeModal() {
        this.setState({
            codeVisible: false,
            codeVisibleTarget: "login",
        });
    }

    checkAgreement(e) {
        this.setState({
            agreement: e.target.checked ? 2 : 1,
        });
    }

    handleLoginChange(e, key) {
        const loginData = JSON.parse(JSON.stringify(this.state.loginForm));
        if (key === 'phone') {
            let val = e.target.value;
            val = val.replace(/[^\d]/g, '');
            if (val.length > 11) {
                val = val.substring(0, 11);
            }
            loginData[key] = val;
        } else {
            loginData[key] = e.target.value;
        }
        this.setState({
            loginForm: loginData,
        });
    }

    handlePasswordChange(e, key) {
        const passwordData = JSON.parse(JSON.stringify(this.state.passwordForm));
        if (key === "phone") {
            let val = e.target.value;
            val = val.replace(/[^\d]/g, "");
            if (val.length > 11) {
                val = val.substring(0, 11);
            }
            passwordData[key] = val;
        } else {
            passwordData[key] = e.target.value;
        }
        this.setState({
            passwordForm: passwordData,
        });
    }

    handleForgotChange(e, key) {
        const forgotData = JSON.parse(JSON.stringify(this.state.forgotForm));
        if (key === "phone") {
            let val = e.target.value;
            val = val.replace(/[^\d]/g, "");
            if (val.length > 11) {
                val = val.substring(0, 11);
            }
            forgotData[key] = val;
        } else if (key === "code") {
            let val = e.target.value;
            val = val.replace(/[^\d]/g, "");
            if (val.length > 6) {
                val = val.substring(0, 6);
            }
            forgotData[key] = val;
        } else {
            forgotData[key] = e.target.value;
        }
        forgotData.err = "";
        this.setState({
            forgotForm: forgotData,
            forgotVerifying: false,
        });
    }

    handlePhoneBlur(e) {
        let val = e.target.value;
        let err = '';
        // const reg = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/;
        const reg = /^[1][0-9]{10}$/;
        if (val && !(reg.test(val))) {
            err = '请输入正确的手机号码';
        } else {
            err = '';
        }
        this.setErr(err);
    }

    handleRegisterChange(e, key) {
        const registerData = JSON.parse(
            JSON.stringify(this.state.registerForm)
        );
        if (key === 'phone') {
            let val = e.target.value;
            val = val.replace(/[^\d]/g, '');
            if (val.length > 11) {
                val = val.substring(0, 11);
            }
            registerData[key] = val;
        } else {
            registerData[key] = e.target.value;
        }
        this.setState({
            registerForm: registerData,
        });
    }

    handleSelectChange(e, key) {
        const registerData = JSON.parse(
            JSON.stringify(this.state.registerForm)
        );
        if (key === 'province') {
            const { areaList } = this.state;
            const city = [];
            areaList.city.forEach(item => {
                if (item.parentId === e) {
                    city.push(item);
                }
            });
            registerData.city = '';
            registerData.distinct = '';
            this.setState({
                cityList: city
            });
        }
        if (key === 'city') {
            const { areaList } = this.state;
            const distinct = [];
            areaList.area.forEach(item => {
                if (item.parentId === e) {
                    distinct.push(item);
                }
            });
            registerData.distinct = '';
            this.setState({
                distinctList: distinct
            });
        }
        registerData[key] = e;
        this.setState({
            registerForm: registerData,
        });
    }

    validateCode() {
        // this.setState({
        //     agreement: data === 1 ? 2 : 1,
        // });
        message.success("验证码已发送，请注意查收");
        if (this.state.codeVisibleTarget === "forgot") {
            this.setState({
                forgotIfSendMsg: true,
                forgotVisible: true,
                forgotStep: "phone",
                forgotForm: {
                    ...this.state.forgotForm,
                    err: "",
                },
            });
            this.countForgot();
        } else if (this.state.loginModdelTab === 1) {
            this.setState({
                registIfSendMsg: true,
            });
            this.countLogin("registTimerCount");
        } else {
            this.setState({
                loginIfSendMsg: true,
            });
            this.countLogin("loginTimerCount");
        }
    }

    countLogin(a) {
        const { loginModdelTab } = this.state;
        let timerCount = this.state[a];
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(() => {
            if (loginModdelTab === 0) {
                this.setState(
                    {
                        loginTimerCount: --timerCount,
                    },
                    () => {
                        if (timerCount <= 0) {
                            clearInterval(this.timer);
                            this.setState({
                                loginIfSendMsg: false,
                                loginTimerCount: 60,
                            });
                        }
                    }
                );
            } else {
                this.setState(
                    {
                        registTimerCount: --timerCount,
                    },
                    () => {
                        if (timerCount <= 0) {
                            clearInterval(this.timer);
                            this.setState({
                                registIfSendMsg: false,
                                registTimerCount: 60,
                            });
                        }
                    }
                );
            }
        }, 1000);
    }

    countForgot() {
        let timerCount = this.state.forgotTimerCount;
        if (this.timer) clearInterval(this.timer);
        this.timer = setInterval(() => {
            this.setState(
                {
                    forgotTimerCount: --timerCount,
                },
                () => {
                    if (timerCount <= 0) {
                        clearInterval(this.timer);
                        this.setState({
                            forgotIfSendMsg: false,
                            forgotTimerCount: 60,
                        });
                    }
                }
            );
        }, 1000);
    }

    doRegist() {
        const { registerForm } = this.state;
        // const reg = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/;
        const reg = /^[1][0-9]{10}$/;
        if (!reg.test(registerForm.phone)) {
            this.setErr("请输入正确的手机号");
            return;
        }
        if (!registerForm.msgCode) {
            this.setErr("请输入手机验证码");
            return;
        }
        if (!registerForm.name) {
            this.setErr("请输入姓名");
            return;
        }
        if (!registerForm.province) {
            this.setErr("请选择省/市/区");
            return;
        }
        if (!registerForm.city) {
            this.setErr("请选择省/市/区");
            return;
        }
        if (!registerForm.distinct) {
            this.setErr("请选择省/市/区");
            return;
        }
        if (!registerForm.company) {
            this.setErr("请输入公司");
            return;
        }
        this.setErr("");
        const params = {
            mobile: registerForm.phone,
            smsCode: registerForm.msgCode,
            name: registerForm.name,
            company: registerForm.company,
            provinceCode: registerForm.province,
            cityCode: registerForm.city,
            districtCode: registerForm.distinct,
        };
        loginApi
            .regist(params)
            .then(() => {
                this.setState({
                    registerForm: {
                        phone: "",
                        msgCode: "",
                        name: "",
                        company: "",
                        province: "",
                        city: "",
                        distinct: "",
                        err: "请准确输入信息，销售经理将尽快通过您填写的信息联系您",
                    },
                    loginModdelTab: 0,
                });
            })
            .catch((err) => {
                if (!err) this.setErr(err);
            });
    }

    openForgotPassword() {
        this.setState({
            forgotVisible: true,
            forgotStep: "phone",
            forgotVerifying: false,
            forgotForm: {
                ...this.state.forgotForm,
                phone: "",
                code: "",
                password: "",
                confirmPassword: "",
                err: "",
            },
        });
    }

    closeForgotPassword() {
        this.setState({
            forgotVisible: false,
            forgotStep: "phone",
            forgotIfSendMsg: false,
            forgotVerifying: false,
            forgotTimerCount: 60,
            codeVisible: false,
            codeVisibleTarget: "login",
            forgotForm: {
                phone: "",
                code: "",
                password: "",
                confirmPassword: "",
                err: "",
            },
        });
    }

    forgotNextStep() {
        const { forgotForm, forgotVerifying } = this.state;
        if (forgotVerifying) return;
        if (!forgotForm.code || forgotForm.code.length !== 6) {
            this.setForgotErr("请输入验证码");
            return;
        }
        this.setState({
            forgotVerifying: true,
            forgotForm: {
                ...forgotForm,
                err: "",
            },
        });
        loginApi
            .verifyCode({
                mobile: forgotForm.phone,
                code: forgotForm.code,
            })
            .then(() => {
                this.setState({
                    forgotStep: "reset",
                    forgotVerifying: false,
                });
            })
            .catch((err) => {
                this.setState({ forgotVerifying: false });
                if (err && err.cancel) return;
                this.setForgotErr(err || "验证码错误");
            });
    }

        // 重置密码：8-25位，须同时包含字母和数字，且不能含6位及以上重复或连续字母或数字
    confirmResetPassword() {
        const { forgotForm } = this.state;
        const passwordValue = (forgotForm.password || "").trim();
        const confirmValue = (forgotForm.confirmPassword || "").trim();
        if (!isValidResetPassword(passwordValue) || confirmValue !== passwordValue) {
            return;
        }
        this.setForgotErr("");
        const payload = encryptByKeySize(JSON.stringify({
            code: forgotForm.code,
            password: passwordValue,
            confirmPassword: confirmValue,
        }));

        if (!payload) {
            this.setForgotErr("密码重置加密失败，请稍后重试");
            return;
        }

        const openId = localStorage.getItem("openId") || sessionStorage.getItem("openId") || "";
        loginApi.forgotPassword({
            mobile: forgotForm.phone,
            openId,
            payload,
        }, { cancelToken: this.cancelToken }).then(() => {
            message.success("密码重置成功");
            this.setState({
                forgotVisible: false,
                forgotStep: "phone",
                forgotIfSendMsg: false,
                forgotVerifying: false,
                forgotTimerCount: 60,
                codeVisible: false,
                codeVisibleTarget: "login",
                authTab: "password",
                forgotForm: {
                    phone: "",
                    code: "",
                    password: "",
                    confirmPassword: "",
                    err: "",
                },
            });
        }).catch((err) => {
            if (!err.cancel) this.setForgotErr(err);
        });
    }

    backForgotStep() {
        if (this.state.forgotStep === "reset") {
            this.setState({
                forgotStep: "phone",
            });
        }
    }

    goToDoc() {
        const url = window.location.href.split('#');
        window.open(url[0] + '/#/doc/7');
    }

    qrIconDom = () => {
        let icon = '';
        if (window.location.href.indexOf('//test') > -1 || window.location.href.indexOf('//localhost') > -1) {
            icon = 'https://img.dmallcdn.com/dshop/202103/6bdfc931-0566-4d5f-a7d4-5b6a037c5076';
        } else if (window.location.href.indexOf('//dev') > -1) {
            icon = 'https://img.dmallcdn.com/dshop/202103/2ab8c209-4a17-4cf5-9717-5e76f0a3e92e';
        } else {
            icon = 'https://img.dmallcdn.com/dshop/202103/a2877e02-a17d-416b-88a2-ea4def24ee0d';
        }
        return <img className="qr_register_icon" src={icon} />
    }

    render() {
        const {
            agreement,
            codeVisible,
            loginForm,
            passwordForm,
            loginTimerCount,
            loginIfSendMsg,
            authTab,
            forgotVisible,
            forgotStep,
            forgotForm,
            forgotTimerCount,
            forgotIfSendMsg,
        } = this.state;
        const { isView } = this.props;
        const isValidLoginPhone = /^[1][0-9]{10}$/.test((loginForm.phone || "").trim());
        const canClickLoginCode = isValidLoginPhone && !loginIfSendMsg;
        let authBody = null;
        if (forgotVisible) {
            authBody = (
                <ForgotPasswordFlow
                    codeCount={forgotTimerCount}
                    codeSending={forgotIfSendMsg}
                    data={forgotForm}
                    err={forgotForm.err}
                    onBack={() => this.backForgotStep()}
                    onCancel={() => this.closeForgotPassword()}
                    onChange={(e, key) => this.handleForgotChange(e, key)}
                    onConfirmReset={() => this.confirmResetPassword()}
                    onNextStep={() => this.forgotNextStep()}
                    onReturnLogin={() => this.setState({ forgotVisible: false, authTab: "password" })}
                    onSendCode={() => this.showCodeModal("forgot")}
                    step={forgotStep}
                />
            );
        } else if (authTab === "password") {
            authBody = (
                        <PasswordLoginPanel
                            agreement={agreement}
                            form={passwordForm}
                            goToDoc={() => this.goToDoc()}
                            onAgreementChange={(e) => this.checkAgreement(e)}
                            onChange={(e, key) => this.handlePasswordChange(e, key)}
                            onForgotPassword={() => this.openForgotPassword()}
                            onSubmit={() => this.doPasswordLogin()}
                        />
            );
        } else {
            authBody = (
                <div className="loginPhoneTab loginTab">
                    <div className="input">
                        <input
                            inputMode="numeric"
                            maxLength={11}
                            onBlur={(e) => this.handlePhoneBlur(e)}
                            onChange={(e) =>
                                this.handleLoginChange(e, "phone")
                            }
                            placeholder="请输入手机号"
                            value={loginForm.phone}
                        />
                    </div>
                    <div className="smsCodeRow">
                        <div className="input codeInput">
                            <input
                                onChange={(e) =>
                                    this.handleLoginChange(e, "msgCode")
                                }
                                placeholder="请输入验证码"
                                value={loginForm.msgCode}
                            />
                        </div>
                        <span
                            className={loginIfSendMsg ? "codeView isSending" : canClickLoginCode ? "codeView isActive" : "codeView"}
                            onClick={canClickLoginCode ? () => this.showCodeModal("login") : undefined}
                        >
                            {loginIfSendMsg
                                ? loginTimerCount + "s后重新获取"
                                : "获取验证码"}
                        </span>
                    </div>
                    <div className="erropTip">
                        {loginForm.err && (
                            <div className="errorTipView">
                                <img src={Images.errorTipPic}></img>
                                <span>{loginForm.err}</span>
                            </div>
                        )}
                    </div>
                    <div
                        className="button"
                        onClick={() => this.doLogin()}
                    >
                        登录
                    </div>
                    <div className="loginTipView">
                        <input
                            checked={agreement === 2 ? "checked" : ""}
                            onChange={(e) => this.checkAgreement(e)}
                            type="checkbox"
                        />
                        <div>
                            我已同意<a onClick={() => this.goToDoc()}>《麦鲜达隐私协议》</a>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div
                className={
                    isView
                        ? "loginModelContainer viewMode"
                        : "loginModelContainer fixed"
                }
            >
                <div className="loginModelView" id="loginBox">
                    {!isView ? (
                        <img
                            className="loginModelClose"
                            onClick={this.removeModel}
                            src={Images.closePic}
                        />
                    ) : null}
                    {!forgotVisible && (
                        <div className="loginModdelTab loginAuthTabs">
                            <div
                                className={
                                    authTab === "sms"
                                        ? "loginOpen active"
                                        : "loginOpen"
                                }
                                onClick={() => {
                                    this.setState({ authTab: "sms", forgotVisible: false });
                                }}
                            >
                                验证码登录
                            </div>
                            <div
                                className={
                                    authTab === "password"
                                        ? "loginPhone active"
                                        : "loginPhone"
                                }
                                onClick={() => {
                                    this.setState({ authTab: "password", forgotVisible: false });
                                }}
                            >
                                密码登录
                            </div>

                        </div>
                    )}
                    {authBody}
                </div>
                {/* <div className="userTrack">
                    <Tooltip color="#ffffff" title={this.qrIconDom()}>
                        <a>非配送客户 账号申请</a>
                    </Tooltip>
                </div> */}
                <CodeModal
                    callBack={(data) => this.validateCode(data)}
                    confirmText="确认"
                    hideCodeModal={() => this.hideCodeModal()}
                    inputPlaceholder="请输入下图中图形验证码"
                    needSupportFsd={this.state.codeVisibleTarget === "register" ? 1 : 0}
                    phone={this.getCurrentPhone()}
                    title="图形验证"
                    visible={codeVisible}
                />
            </div>
        );
    }
}
export default withRouter(LoginModel);
